import {type AgentActionDef} from '../agentActions';
import {summarizeRunFilter} from './agentActionFilter';

/**
 * The `set_run_filter` UI action: sets the current workspace's run filter.
 *
 * `toolName` must match the backend tool name (`ui_actions.py`); it's the single
 * source of truth — the catalog keys on it and the handler slice registers
 * under it.
 */
export const RUN_FILTER_ACTION: AgentActionDef = {
  toolName: 'wbui__set_run_filter',
  name: 'Run Filter',
  icon: 'filter-alt',
  label: summarizeRunFilter,
};
